var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dreambuddy2-cart-container",class:_vm.items && _vm.items.length ? '' : 'hidden',on:{"click":_vm.checkout}},[_c('div',{staticClass:"cart-icon",domProps:{"innerHTML":_vm._s(_vm.addToCartIcon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }